import { HomeVariantIcon } from './HomeVariantIcon';

/**
 * author: Google
 * id 7AFA8EEF-6A41-4A7D-97D2-F9F03DB24DB0
 * name home-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-variant.svg
 * tags
 * - Home Automation 
 */
export const HouseVariantIcon = HomeVariantIcon;
export default HouseVariantIcon